var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLeftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 8,
    viewBox: "0 0 5 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00265126 3.99891C0.00265126 3.82129 0.0601573 3.64366 0.183384 3.50343L3.08333 0.203334C3.32157 -0.0677781 3.71589 -0.0677781 3.95413 0.203334C4.19237 0.474447 4.19237 0.923185 3.95413 1.1943L1.48959 3.99891L3.95413 6.80352C4.19237 7.07464 4.19237 7.52338 3.95413 7.79449C3.71589 8.0656 3.32157 8.0656 3.08333 7.79449L0.183384 4.49439C0.0601574 4.35416 0.00265126 4.17654 0.00265126 3.99891Z",
    fill: "#F6F6F6"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftIcon);
export default __webpack_public_path__ + "static/media/LeftIcon.5821382ec5feb379235fd97ff070f6d3.svg";
export { ForwardRef as ReactComponent };